import { Star } from "lucide-react";
import { REVIEWS } from "../../data/tilio";
import { Reveal, SectionHeading } from "./Shared";

export default function Reviews() {
    return (
        <section id="opinie" data-testid="reviews-section" className="border-t border-stone/70 bg-[#F5F8F4]">
            <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    number="06"
                    eyebrow="Opinie gości"
                    title="To nie tylko nasza historia."
                    sub="Posłuchaj, co mówią goście."
                    center
                    testId="reviews-heading"
                />
                <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
                    {REVIEWS.map((r, i) => (
                        <Reveal key={`review-${i}`} delay={i * 0.1} className="h-full">
                            <figure
                                data-testid={`review-card-${i}`}
                                className="flex h-full flex-col border border-stone bg-ivory p-8"
                            >
                                <div className="flex gap-1" aria-label="5 na 5 gwiazdek">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star key={s} className="h-3.5 w-3.5 fill-pine text-pine" strokeWidth={1} />
                                    ))}
                                </div>
                                <blockquote className="mt-6 flex-1 font-serif text-2xl leading-relaxed text-pine">
                                    „{r.text}”
                                </blockquote>
                                <figcaption className="mt-8 border-t border-stone/70 pt-5">
                                    <p className="text-sm font-semibold uppercase tracking-[0.2em] text-pine">{r.author}</p>
                                    <p className="mt-1 text-sm text-muted-foreground">{r.context}</p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
